import Seo from './Seo'
import { abs, breadcrumbJsonLd } from '../../lib/seo'
import type { Tool } from '../../lib/blog/types'

/** SEO head for a tool page: WebApplication + BreadcrumbList JSON-LD. No fabricated rating/price. */
export default function ToolSeo({ tool }: { tool: Tool }) {
  const path = `/tools/${tool.slug}`

  const webApp = {
    '@context': 'https://schema.org',
    '@type': 'WebApplication',
    name: tool.title,
    description: tool.description,
    url: abs(path),
    applicationCategory: 'FinanceApplication',
    operatingSystem: 'Web',
  }

  const breadcrumbs = breadcrumbJsonLd([
    { name: 'Home', path: '/' },
    { name: 'Tools', path: '/tools' },
    { name: tool.title, path },
  ])

  return (
    <Seo
      title={`${tool.title} | BankStatementReader`}
      description={tool.description}
      canonicalPath={path}
      ogType="website"
      jsonLd={[webApp, breadcrumbs]}
    />
  )
}
